import CVAttributeReducer from 'store/cv-attribute/reducers';

export { default as cvAttributeTypes } from 'store/cv-attribute/types';
export { default as cvAttributeSelectors } from 'store/cv-attribute/selectors';

export default CVAttributeReducer;
